export default __webpack_public_path__ + "static/media/Tinos-BoldItalic.ecd7d869.ttf";